import { Box, Typography } from "@mui/material";
import RoundedTextField from "./RoundedTextField";
import { RegionalLocationList } from "../constants/RegionalLocationList";
import useValidation from "../hooks/useValidation";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateFields } from "../redux/profileSlice";

export const Local = ({ values, handleChange, edit, handleDisable }) => {
  const { errors } = useValidation({
    city: values.primaryCity,
    province: values.province,
  });
  const dispatch = useDispatch();
  const [city, setCity] = useState(values.primaryCity ?? "");
  const [province, setProvince] = useState(values.province ?? "");
  const displayedCity = edit ? city : (values.primaryCity ?? "");
  const displayedProvince = edit ? province : (values.province ?? "");
  const disabled = !displayedCity.trim() || !displayedProvince.trim();

  useEffect(() => {
    handleDisable?.(disabled);
  }, [disabled, handleDisable]);

  const handleCityInputChange = (e) => {
    setCity(e.target.value);
    dispatch(
      updateFields({
        field: "sponsorProfile.primaryCity",
        value: e.target.value,
      }),
    );
  };
  const handleProvinceInputChange = (e) => {
    setProvince(e.target.value);
    dispatch(
      updateFields({ field: "sponsorProfile.province", value: e.target.value }),
    );
  };

  return (
    <>
      <Box sx={{ marginTop: "20px" }}>
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: "14px",
            color: "#152134",
            textAlign: "left",
            marginBottom: "5px",
          }}
        >
          Your City
        </Typography>
        <RoundedTextField
          name={edit ? "sponsorProfile.primaryCity" : "primaryCity"}
          variant="outlined"
          placeholder="Enter here"
          fullWidth
          value={displayedCity}
          onChange={edit ? handleCityInputChange : handleChange}
          sx={{
            "& .MuiOutlinedInput-input": {
              color: "#2A4876",
            },
          }}
        />
      </Box>
      <Box sx={{ marginTop: "20px", marginBottom: "20px" }}>
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: "14px",
            color: "#152134",
            textAlign: "left",
            marginBottom: "5px",
          }}
        >
          Your Province
        </Typography>
        <RoundedTextField
          name={edit ? "sponsorProfile.province" : "province"}
          variant="outlined"
          placeholder="Enter here"
          fullWidth
          type="text"
          value={displayedProvince}
          error={errors.province}
          helperText={errors.province}
          onChange={edit ? handleProvinceInputChange : handleChange}
          sx={{
            "& .MuiOutlinedInput-input": {
              color: "#2A4876",
            },
          }}
        />
      </Box>
    </>
  );
};

export const International = ({
  values,
  handleChange,
  edit,
  handleDisable,
}) => {
  const [countriesOrCities, setCountriesOrCities] = useState(
    Array.isArray(values.countriesOrCities)
      ? values.countriesOrCities.join(", ")
      : (values.countriesOrCities ?? ""),
  );
  const dispatch = useDispatch();
  const displayedCountries = edit
    ? countriesOrCities
    : Array.isArray(values.countriesOrCities)
      ? values.countriesOrCities.join(", ")
      : (values.countriesOrCities ?? "");
  const disabled = !displayedCountries.split(",").some((value) => value.trim());
  useEffect(() => {
    handleDisable?.(disabled);
  }, [disabled, handleDisable]);

  const handleInputChange = (e) => {
    setCountriesOrCities(e.target.value);
    dispatch(
      updateFields({
        field: "sponsorProfile.countriesOrCities",
        value: e.target.value
          .split(",")
          .map((value) => value.trim())
          .filter(Boolean),
      }),
    );
  };
  return (
    <>
      <Box sx={{ marginTop: "20px", marginBottom: "20px" }}>
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: "14px",
            color: "#152134",
            textAlign: "left",
            marginBottom: "5px",
          }}
        >
          Countries/Cities
        </Typography>
        <RoundedTextField
          name={edit ? "sponsorProfile.countriesOrCities" : "countriesOrCities"}
          variant="outlined"
          placeholder="Enter here"
          fullWidth
          type="text"
          value={displayedCountries}
          //error={errors.city}
          //helperText={errors.city}
          onChange={edit ? handleInputChange : handleChange}
          sx={{
            "& .MuiOutlinedInput-input": {
              color: "#2A4876",
            },
          }}
        />
      </Box>
    </>
  );
};

export const Regional = ({ handleSelect, selected, edit, handleDisable }) => {
  const [selectedRegions, setSelectedRegions] = useState(selected ?? []);
  const disabled = (edit ? selectedRegions : (selected ?? [])).length === 0;
  useEffect(() => {
    handleDisable?.(disabled);
  }, [disabled, handleDisable]);

  const dispatch = useDispatch();
  const handleSelectRegions = (region) => {
    let regions;
    if (selectedRegions?.includes(region)) {
      // If language is already selected, remove it
      regions = selectedRegions.filter((int) => int !== region);
    } else {
      // Otherwise, add the language to the array
      regions = [...selectedRegions, region];
    }
    setSelectedRegions(regions);
    dispatch(
      updateFields({
        field: "sponsorProfile.regions",
        value: regions,
      }),
    );
  };
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "10px",
        }}
      >
        {RegionalLocationList.map((region) => (
          <button
            key={region}
            style={{
              ...styles.optionButton,
              backgroundColor: edit
                ? selectedRegions?.includes(region)
                  ? "#7BB9D5"
                  : "#ffffff"
                : selected?.includes(region)
                  ? "#7BB9D5"
                  : "#ffffff",
              borderColor: edit
                ? selectedRegions?.includes(region)
                  ? "#7BB9D5"
                  : "#AAB6C8"
                : selected?.includes(region)
                  ? "#7BB9D5"
                  : "#AAB6C8",
              fontWeight: edit
                ? selectedRegions?.includes(region)
                  ? 600
                  : 400
                : selected?.includes(region)
                  ? 600
                  : 400,
            }}
            onClick={() => {
              edit ? handleSelectRegions(region) : handleSelect(region);
            }}
          >
            {region}
          </button>
        ))}
      </Box>
    </>
  );
};

const styles = {
  optionButton: {
    padding: "10px 15px",
    border: "1px solid #ddd",
    borderRadius: "20px",
    cursor: "pointer",
    fontSize: "14px",
    color: "#2b3b4b",
    outline: "none",
  },
};
